import { useMessage } from "../../../fetch/fetch.message";
import ErrMessage from "../../core/ErrMessage";
import UserTitle from "../../user/core/UserTitle";
import { LOADING_CIRCLE } from "../../core/loading/LoadingCircle.tsx";
import { useCurrentUser } from "../../../hooks/useCurrentUser.ts";

const ChatBubbles = ({ chatId }: { chatId: string }) => {
  const currentUser = useCurrentUser();
  const dates = new Set<string>();
  const { messages, isLoading, isError } = useMessage(chatId, []);
  if (isLoading)
    return (
      <div className={`chat chat-end`}>
        <div className="chat-bubble break-all">{LOADING_CIRCLE}</div>
      </div>
    );
  if (isError) return <ErrMessage message={isError.message} />;
  let writtenBy = "";
  return (
    <div className="flex flex-col justify-end">
      {messages.map((message) => {
        const mHeader = dates.has(
          new Date(message.createdAt).toLocaleDateString(),
        ) ? null : (
          <div className="sticky top-0 chat-header divider bg-base-100 z-1">
            <div className="opacity-50 ">
              {new Date(message.createdAt).toLocaleDateString("de-DE", {
                day: "2-digit",
                month: "2-digit",
              })}{" "}
            </div>
          </div>
        );
        dates.add(new Date(message.createdAt).toLocaleDateString());
        const userChanged = writtenBy !== message.writtenBy;
        writtenBy = message.writtenBy;
        return (
          <div key={message._id}>
            {mHeader}
            <div
              className={`chat ${message.writtenBy === currentUser ? "chat-end" : "chat-start"}`}
            >
              {userChanged && (
                <div className="chat-header">
                  <UserTitle userId={message.writtenBy} />
                </div>
              )}

              <div className="chat-bubble whitespace-break-spaces break-all">
                {message.content}
              </div>
              <div className="chat-footer opacity-50">
                {new Date(message.createdAt).toLocaleTimeString("de-DE", {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default ChatBubbles;
